import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface AdminStatCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
  delta?: string;
  variant?: "default" | "warning" | "success";
}

const variantRing: Record<NonNullable<AdminStatCardProps["variant"]>, string> = {
  default: "bg-primary/15 text-primary",
  warning: "bg-amber-500/15 text-amber-400",
  success: "bg-emerald-500/15 text-emerald-400",
};

/** StatCard de Super Admin (Platform/Partners) — distinto del StatCard del Design System en `@/components/ds`. */
export function AdminStatCard({ title, value, icon: Icon, delta, variant = "default" }: AdminStatCardProps) {
  return (
    <div className="glass-card flex gap-4 rounded-xl p-4">
      <div
        className={cn(
          "flex h-11 w-11 shrink-0 items-center justify-center rounded-full",
          variantRing[variant],
        )}
      >
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium text-muted-foreground">{title}</p>
        <p className="truncate text-2xl font-bold tabular-nums text-foreground">{value}</p>
        {delta && <p className="text-[11px] text-muted-foreground">{delta}</p>}
      </div>
    </div>
  );
}
